export class FileDto {

  public contentType: string;
  public fileName: string;
  public uploaderId: number;
  public uploadTime: any;
  public description: string;
  public type: string;
  public fileId: string;
  public size: number;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/common/dtos/FileDto.ts